<template>
  <li class="wzc_option" :style="styleVar" @click.stop="currentSelect">
    <div class="wzc_option_dropdown_item">{{ label }}</div>
  </li>
</template>

<script>
export default {
  name: "wzc_option",
  props: {
    width: {
      type: Number,
      default: -1,
    },
    height: {
      type: Number,
      default: 34,
    },
    label: {
      type: String,
    },
    optionid: {},
    isTrue:{
      type: Boolean,
      default: false
    },
    isBgc:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleVar() {
      return {
        "--option-height": this.height + "px",
        "--option-width": this.width == -1 ? "100%" : this.width + "px",
        "background": this.isBgc ? "#FFF9EB" : "#FFFFFF"
      };
    },
  },
  mounted() {
    if(this.isTrue){
      this.currentSelect()
      this.$parent.isListShow = !this.$parent.isListShow;
    }
  },
  methods: {
    currentSelect() {
      this.$parent.label = this.label;
      this.$parent.optionid = this.optionid;
      this.$parent.isListShow = !this.$parent.isListShow;
      this.$emit('slot-content', {label: this.label, optionid: this.optionid});
    }
  },
};
</script>

<style scoped>
.wzc_option {
  list-style: none;
  height: var(--option-height);
  width: var(--option-width);
  color: #1D1D1D;
}

.wzc_option-select {
  background: #FFF4D8;
  font-size: 14px;
  color: #1D1D1D;
}

.wzc_option_dropdown_item {
  height: 100%;
  width: calc(100% - 20px);
  line-height: var(--option-height);
  cursor: pointer;
  margin: 0 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>